<template>
    <div :class="['row-livechat', 'mt-2']">
        <div :class="['col-4', 'col-lg-5', 'pr-0']">
            <div :class="$style.__email">
                <i :class="['material-icons', $style.__icon]">email</i>
                <div>Email</div>
            </div>
        </div>
        <div :class="['col-8', 'col-lg-7', 'pl-0']">
            <input 
                :type="'text'" 
                :value="email"
                @input="$emit('input', $event.target.value)"
                :class="['form-control', $style.__input]"  
                :placeholder="[this.$t('input.email')]"
            >
        </div>
    </div>
</template>

<style lang="scss" module scoped>
    .__email {
        background: #e3e3e3;
        -webkit-border-top-left-radius: 8px;
        -webkit-border-bottom-left-radius: 8px;
        -moz-border-radius-topleft: 8px;
        -moz-border-radius-bottomleft: 8px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        height: 32px;
        border: 1px solid #ccc;
        border-right: 0px;
        width: 100%;
        padding-left: 8px;
        padding-right: 5px;
        padding-top: 5px;
        text-align: left;
    }
  
    .__email {
        line-height: 150%;
        .__icon {
            font-size: 14px;
            color:#a7a7a7;
        }
        div {
            font-size: 12px;
            display: inline-block;
            margin-left: 10px;
            position: absolute;
            top: 5px;
        }
    }
    .__input {
        height: 32px !important;
        border-left: 0px !important;
        padding: 0 10px !important;
        width: calc(100%) !important;
        -webkit-border-radius: 8px !important;
        -webkit-border-top-left-radius: 0px !important;
        -webkit-border-bottom-left-radius: 0px !important;
        -moz-border-radius: 8px !important;
        -moz-border-radius-topleft: 0px !important;
        -moz-border-radius-bottomleft: 0px !important;
        border-radius: 8px !important;
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
        font-size: 12px !important;
    }

     @media screen and (min-width: 769px) {
        .__input {
            height: 24px !important;
        }
        .__radio, .__email { 
            height: 24px;
            padding-top: 0px;


        }
        .__email {
            .__icon {
                position: relative;
                top: 1px;
            }
            div {
                top: 1px;
            }
        }
     
      
    }

</style>

<script>
export default {
    props: {
        email: String
    },
}
</script>